class Form {
	constructor(formEl) {
		this.form = formEl;
		this.initSubmitButton();
	}

	initSubmitButton() {
		const submitBtn = this.form.querySelector('input[type="submit"]');

		if (submitBtn) {
			// Create wrapper
			const wrapper = document.createElement('div');
			wrapper.classList.add('button-wrapper');

			// Insert wrapper before the button and move button into it
			submitBtn.parentNode.insertBefore(wrapper, submitBtn);
			wrapper.appendChild(submitBtn);

		}
	}

}

export default Form;